const formatDate = date => {
  const d = new Date(date);
  return d.toLocaleString('sv-SE', {
    dateStyle: 'short',
  });
};

export default formatDate;
